<template>
  <div
    class="field checkbox-field"
    :class="{ 'checkbox-field--switch': isSwitch }"
    :style="field.style"
    v-if="condition"
  >
    <label class="label checkbox-field__label" :for="inputId">
      <span v-if="!local_value.label_icon">
        {{ local_value.label }}
      </span>
      <span v-else>
        <i :class="local_value.label_icon"></i>
      </span>
      {{ local_value.required ? " *" : "" }}
    </label>
    <div
      class="control"
      :class="[
        isSwitch ? 'checkbox-field__switch-wrap' : 'has-text-centered',
        local_value.left_icon ? 'has-icons-left' : '',
        local_value.right_icon ? 'has-icons-right' : '',
      ]"
    >
      <label v-if="isSwitch" class="checkbox-switch">
        <input
          :id="inputId"
          type="checkbox"
          class="checkbox-switch__input"
          :true-value="1"
          :false-value="0"
          :disabled="isDisabled"
          @change="onChange"
          v-model="local_value.value"
          :name="local_value.name"
        />
        <span class="checkbox-switch__track"></span>
      </label>
      <input
        v-else
        :id="inputId"
        type="checkbox"
        class="checkbox-field__input"
        :true-value="1"
        :false-value="0"
        :disabled="isDisabled"
        @change="onChange"
        v-model="local_value.value"
        :name="local_value.name"
      />
      <span class="icon is-small is-left" v-if="local_value.left_icon">
        <i :class="local_value.left_icon"></i>
      </span>
      <span class="icon is-small is-right" v-if="local_value.right_icon">
        <i :class="local_value.right_icon"></i>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["field", "fields"],
  data() {
    return {
      local_value: null,
    };
  },
  computed: {
    inputId() {
      const name = this.local_value?.name || this.field?.name || "checkbox";
      return `daform-checkbox-${name}`;
    },
    isSwitch() {
      return this.local_value?.variant === "switch" || this.field?.variant === "switch";
    },
    isDisabled() {
      // Product <-> accessory toggle must always stay clickable.
      if (this.local_value?.name === "is_accessory") return false;
      return !!(this.local_value?.readonly || this.local_value?.disabled);
    },
    condition() {
      var is_visible = true;
      if (!this.local_value) return false;
      if (this.local_value.vif) {
        if (this.fields)
          this.fields.map((f) => {
            if (f.length) {
              f.map((ff) => {
                this.local_value.vif.map((c) => {
                  if (ff.name == c.field) {
                    if (c.value_not !== undefined) is_visible = ff.value != c.value_not;
                  }
                });
              });
            } else {
              this.local_value.vif.map((c) => {
                if (f.name == c.field) {
                  if (c.value_not !== undefined) {
                    is_visible = f.value != c.value_not;
                  }
                  if (c.value !== undefined) {
                    is_visible = f.value == c.value;
                  }
                }
              });
            }
          });
      }
      return is_visible;
    },
  },
  methods: {
    syncFromField(val) {
      const next = { ...(val || {}) };
      // Normalize checkbox values to 0/1 so v-model with true/false-value works.
      if (next.value === true || next.value === "1" || next.value === 1) next.value = 1;
      else if (next.value === false || next.value === "0" || next.value === 0 || next.value == null || next.value === "") next.value = 0;
      if (next.name === "is_accessory") {
        next.readonly = false;
        next.disabled = false;
      }
      this.local_value = next;
    },
    onChange() {
      if (this.isDisabled) return;
      this.$emit("syncField", { ...this.local_value });
    },
  },
  watch: {
    field: {
      handler(val) {
        this.syncFromField(val);
      },
      deep: true,
    },
  },
  created() {
    this.syncFromField(this.field);
  },
};
</script>

<style scoped>
.label {
  margin-bottom: 0 !important;
  color: grey;
}
.checkbox-field__label {
  cursor: pointer;
  user-select: none;
}
.checkbox-field__input {
  cursor: pointer;
  width: 18px;
  height: 18px;
}
.checkbox-field__input:disabled {
  cursor: not-allowed;
}
.checkbox-field--switch {
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
}
.checkbox-field__switch-wrap {
  text-align: left;
}
.checkbox-switch {
  position: relative;
  display: inline-block;
  width: 42px;
  height: 24px;
  cursor: pointer;
}
.checkbox-switch__input {
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
}
.checkbox-switch__track {
  position: absolute;
  inset: 0;
  background: #cbd5e1;
  border-radius: 999px;
  transition: background 0.15s ease;
}
.checkbox-switch__track::after {
  content: "";
  position: absolute;
  width: 18px;
  height: 18px;
  left: 3px;
  top: 3px;
  background: #fff;
  border-radius: 50%;
  transition: transform 0.15s ease;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.2);
}
.checkbox-switch__input:checked + .checkbox-switch__track {
  background: #7c3aed;
}
.checkbox-switch__input:checked + .checkbox-switch__track::after {
  transform: translateX(18px);
}
.checkbox-switch__input:disabled + .checkbox-switch__track {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
